<template>
    <form @submit.prevent="submit" @keydown="errors.clear($event.target.name)">

        <base-input class="mb-3"
            :label="$t('common.name')"
            :placeholder="$t('common.name')"
            required
            v-model="value.name"
            name="name"
            :error="errors.get('name')">
        </base-input>

        <base-select class="mb-3" v-if="Object.keys(entities).length > 0 && !(value.id && !value.entity_id)"
            :label="$t('common.entity')"
            :placeholder="$t('common.entity')"
            v-model="value.entity_id"
            :options="entities"
            :disabled="value.id !== null || $auth.user.entity_id !== null"
            clearable>
        </base-select>

        <base-checkbox class="mb-3" v-model="value.active">
            {{ $t('common.active') }}
        </base-checkbox>

        <div class="mt-4 mb-4" v-if="!value.admin && permissions['xapi-scopes'] !== undefined">
            <h4 class="card-title mb-2">{{ $t('xapi.common.authorization-scopes') }}</h4>
            <base-checkbox v-for="(permission, key) in permissions['xapi-scopes'].permissions" :key="key"
                v-model="value.permissions[key]">

                {{ permission.name }}
            </base-checkbox>
        </div>

        <div class="mt-4 mb-4" v-if="!value.admin">
            <h4 class="card-title mb-2">{{ $t('xapi.common.extra-permissions') }}</h4>
            <base-checkbox v-for="(permission, key) in permissions['xapi-extra'].permissions" :key="key"
                v-model="value.permissions[key]">

                {{ permission.name }}
            </base-checkbox>
            <base-checkbox v-for="(permission, key) in permissions['cmi5'].permissions" :key="key"
                v-model="value.permissions[key]">

                {{ permission.name }}
            </base-checkbox>
        </div>

        <h4 class="card-title mb-2">{{ $t('xapi.common.authority') }}</h4>

        <base-input class="mb-2"
            :placeholder="$t('common.name')"
            v-model="value.meta.authority.name"
            name="meta.authority.name"
            :error="errors.get('meta.authority.name')">
        </base-input>

        <base-input class="mb-4"
            :placeholder="$t('xapi.common.homePage')"
            v-model="value.meta.authority.homePage"
            name="meta.authority.homePage"
            :error="errors.get('meta.authority.homePage')">
        </base-input>

        <div class="category form-category mb-3">* {{ $t('common.required-fields') }}</div>

        <div class="buttons pt-2 text-center">
            <base-button type="primary" native-type="submit" :disabled="errors.any()">
                {{ value.id ? $t('common.update') : $t('common.create') }}
            </base-button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                {{ $t('common.cancel') }}
            </button>
        </div>

    </form>
</template>

<script>
    export default {
        props: ['value', 'errors', 'entities', 'permissions'],
        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
